<template>
  <b-modal
    id="manage-activities-domain-modal"
    title="Déplacer les activités"
    scrollable
    hide-footer>
    <b-alert variant="warning" :show="disableDomain">
      Avant de pouvoir désactiver le domaine <b>{{ domain?.dac_label }}</b>, vous avez <b>{{ activities.length }}</b> activité(s) à déplacer.
    </b-alert>
    <div class="text-center">
      Déplacer toutes les activités vers
      <b-form @submit.prevent="moveActivities(true)">
        <b-input-group class="mt-3">
          <b-form-select
            v-model="selectedDomain"
            :options="getDomainsExceptSelected"
            value-field="dac_id"
            text-field="dac_label">
          </b-form-select>
          <b-input-group-append>
            <b-button type="submit" :disabled="!selectedDomain" variant="primary">Envoyer</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form>
    </div>
    <div class="text-center" style="margin: 5px 0;">Ou individuellement</div>
    <b-table
      :fields="fields"
      :items="activities">

      <template #cell(actions)="row">
        <b-form-select
          v-model="row.item.dac_id"
          :options="getDomainsWithEmptyOption"
          value-field="dac_id"
          text-field="dac_label">
        </b-form-select>
      </template>

    </b-table>
    <div class="text-center" style="position: sticky;bottom: 0">
      <b-button :disabled="!checkForIndividualMove" variant="primary" type="submit"  @click="moveActivities(false)">Envoyer</b-button>
    </div>
  </b-modal>
</template>

<script>
import { moveActivitiesToDomain } from '../services/establishment';

export default {
  props: {
    establishment: {
      type: Object,
      required: true,
    },
    domains: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      domain: null,
      activities: [],
      selectedDomain: null,
      disableDomain: true,
    };
  },
  computed: {
    getDomainsExceptSelected() {
      return this.domains?.filter((domain) => {
        return domain.dac_id !== this.domain?.dac_id && domain.dac_is_enable;
      }) ?? [];
    },
    getDomainsWithEmptyOption() {
      return [
        { dac_id: null, dac_label: '---' },
        ...this.getDomainsExceptSelected
      ];
    },
    fields() {
      return [
        {
          label: {
            label: this.$t('label.name'),
            sortable: true,
          }
        },
        {
          type: {
            label: this.$t('label.activity_type'),
            sortable: false,
          }
        },
        {
          actions: {
            label: this.$t('label.action'),
            sortable: false,
          }
        },
      ];
    },
    checkForIndividualMove() {
      return this.disableDomain ?
        // All activites must be setted to domain
        (this.activities?.every((a) => a.dac_id !== null) ?? false)
        :
        // At least one activity must be setted to domain
        (this.activities?.some((a) => a.dac_id !== null) ?? false);
    }
  },
  methods: {
    show(domain, activities, disableDomain) {
      this.domain = domain;
      this.activities = activities.map((a) => ({...a, dac_id: null}));
      this.disableDomain = disableDomain;
      this.selectedDomain = null;
      this.$bvModal.show("manage-activities-domain-modal");
    },
    hide() {
      this.$bvModal.hide("manage-activities-domain-modal");
    },
    async moveActivities(allSame) {
      this.loading = true;
      if (allSame) {
        this.activities.forEach((a) => {
          a.dac_id = this.selectedDomain;
        });
      }
      // Check if all/some activites have a domain
      if (!this.checkForIndividualMove) {
        return
      }
      try {
        const activities = this.disableDomain ? this.activities : this.activities.filter((a) => a.dac_id !== null);
        const res = await moveActivitiesToDomain(this.establishment.esta_id, activities)
        if (res) {
          this.$emit('onMoved', this.disableDomain ? this.domain : null);
          this.hide();
          this.showToast('success', this.$t('label.activities_moved'), this.$t('label.activity'))
        }
      } catch {
        this.showToast('error', this.$t('error.general'), this.$t('label.activity'))
      }
      this.loading = false;
    }
  }
};
</script>
